var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailReject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "170px",
    height: "152px",
    viewBox: "0 0 170 152",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "03") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M158,52.4252848 L158,121.067949 C158,121.358082 158,121.503857 158,121.79399 C157.855167,125.711494 155.956718,129.194507 153.18217,131.516987 C150.700129,133.693693 147.488242,135 143.98385,135 L32.8713174,135 C30.3892759,135 28.1997405,134.419734 26.1550382,133.259201 C25.2789401,132.823294 24.4028419,132.243028 23.6729968,131.516987 C22.0670535,130.210681 20.7521963,128.469882 20.0223512,126.437535 C19.438759,124.986869 19,123.534788 19,121.938349 L19,52.4252848 C19,52.4252848 24.8416009,47.4916066 33.1638234,40.6713554 C41.7785519,33.415197 53.1664079,24.1266915 63.0945736,15.8543595 C68.7899215,11.0664554 68.2049095,11.6467217 76.965891,4.244789 C83.6821701,-1.41492967 93.4655028,-1.41492967 100.181782,4.244789 C101.933978,5.69686986 103.686175,7.29330964 105.438371,8.74397522 C109.087597,11.6467217 113.175581,15.1297343 117.409819,18.612747 C126.317053,26.0132644 136.098966,34.1398221 143.837597,40.5255812 C151.72248,47.0556993 157.416408,51.8450186 158,52.4252848 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-10.4%",
    y: "-7.0%",
    width: "120.9%",
    height: "121.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 5,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.11372549   0 0 0 0 0.990412896   0 0 0 0 1  0 0 0 0.22 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.0762029175%",
    y1: "50.7140369%",
    x2: "99.7532477%",
    y2: "50.7140369%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF1642",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF1642",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.16276611%",
    y1: "49.9545805%",
    x2: "102.080294%",
    y2: "49.9545805%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#599CA2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#195C62",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "55.7319046%",
    y1: "53.6283833%",
    x2: "47.9781642%",
    y2: "46.4204233%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#184347",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A8D93",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "95.757973%",
    y1: "49.9545805%",
    x2: "-3.2388664%",
    y2: "49.9545805%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#509399",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#408389",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.233405241%",
    y1: "50.2216312%",
    x2: "99.9964636%",
    y2: "50.2216312%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B7A80",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B7A80",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.233405241%",
    y1: "48.1382979%",
    x2: "99.9964636%",
    y2: "48.1382979%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B7A80",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36757B",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.3---L---Resend-Email-(Sent)-Copy",
    transform: "translate(-263.000000, -427.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3,
    transform: "translate(263.000000, 430.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.5007093,149 C128.541654,149 161,116.763746 161,77 C161,37.2348416 128.541654,5 88.5007093,5 C48.4597646,5 16,37.2348416 16,77 C16,116.763746 48.4597646,149 88.5007093,149 Z",
    id: "Path",
    fill: "#D2E4E6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#38777D",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M144,40.7919679 L144,65.5839358 L119.755813,80.167279 L112.452303,84.5419975 L97.1166362,93.7294753 L89.8145466,98.1041938 L86.7479814,100 L83.8262934,98.1041938 L76.9616758,93.7294753 L62.3560762,84.5419975 L55.492879,80.167279 L33,66.0205543 L33,40.9384555 C41.6173464,33.6467839 53.0086629,24.3128185 62.941266,16 L117.273017,18.7718876 C126.62043,26.2086247 136.405315,34.3749556 144,40.7919679 Z",
    id: "Path",
    fill: "#397E84",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,21.2278768 L139,64.249648 L116.814832,77.3869373 L110.247284,81.2854641 L96.2350015,89.5133409 L89.6674537,93.4118677 L86.8939528,95 L84.2666498,93.4118677 L77.9914977,89.5133409 L64.7102042,81.2854641 L58.4336327,77.3869373 L38,64.683287 L38,21.2278768 C38,16.7535112 41.6492685,13 46.3190832,13 L130.680917,13 C135.204534,13 139,16.7535112 139,21.2278768 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#E7EBF2",
    fillRule: "nonzero",
    points: "96 90 89.520112 94 84.191395 94 78 90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.107882,31 L71.8921184,31 C70.8731766,31 70,30.1431557 70,28.9993034 C70,27.8568443 70.8731766,27 71.8921184,27 L107.107882,27 C108.126823,27 109,27.8568443 109,28.9993034 C109,30.1431557 108.126823,31 107.107882,31 Z",
    id: "Path",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon/Slash",
    transform: "translate(68.000000, 38.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "24pt-Bounding-Box",
    opacity: 0,
    fillRule: "nonzero",
    points: "0 0 42 0 42 42 0 42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9999992,3.5 L20.9999992,3.5 C11.3350117,3.5 3.49999924,11.3350125 3.49999924,21 C3.49999924,30.6649875 11.3350117,38.5 20.9999992,38.5 C30.6649867,38.5 38.4999992,30.6649875 38.4999992,21 L38.4999992,21 C38.4999992,11.3350133 30.6649867,3.5 20.9999992,3.5 L20.9999992,3.5 Z M35.0000156,21 L35.0000156,20.9999721 C35.0038705,24.1091368 33.9622307,27.1292868 32.0425175,29.5749818 L12.4250162,9.95748184 L12.4250162,9.95748284 C14.8707287,8.03776784 17.8908612,6.99611534 21.0000162,6.99997211 L21.0000156,6.99997211 C28.7320056,6.99997211 35.0000156,13.2679928 35.0000156,20.9999828 L35.0000156,21 Z M6.99998224,21 L6.99998224,21.0000189 C6.99612934,17.8908639 8.03776927,14.8707139 9.95748252,12.4250189 L29.5749829,32.0425189 L29.5749829,32.0425187 C27.1292704,33.9622337 24.1091379,35.0038862 20.9999822,35.0000294 L20.9999822,35.0000294 C13.2679922,35.0000294 6.99998224,28.7320087 6.99998224,21.0000187 C6.99998224,21.0000187 6.99998224,21.0000187 6.99998224,21.0000187 L6.99998224,21 Z",
    id: "Fill",
    fill: "#DF1642"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M158,52 L158,121.725975 C157.855167,125.665078 155.956718,129.164607 153.18217,131.499049 C150.700129,133.686965 147.488242,135 143.98385,135 L32.8713174,135 C30.3892759,135 28.1997405,134.416745 26.1550382,133.250236 C25.2789401,132.812083 24.4028419,132.228829 23.6729968,131.499049 C22.0670535,130.186014 20.7521963,128.43625 20.0223512,126.393436 C19.438759,124.935299 19,123.475739 19,121.8725 L19,121.725975 L19,52 L81.2001287,90.9471934 L86.6029706,94.3030422 L88.5,93.1351101 L90.2521963,92.1151255 L158,52 Z",
    id: "Path",
    fill: "#738DFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,131.499049 C150.524027,133.686965 147.319993,135 143.824169,135 L32.837403,135 C30.36143,135 28.1772478,134.416745 26.1375447,133.250236 C25.2635885,132.812083 24.3896324,132.228829 23.6615716,131.499049 C22.0595548,130.186014 20.7479123,128.43625 20.0198516,126.393436 C19.4376863,124.935299 19,123.475739 19,121.8725 L19,121.725975 L19,52 L26.2834401,56.3758334 L88.3300776,93.2816351 L90.0779899,94.3030422 L90.2238853,94.4481447 L145.862455,127.414843 L153,131.499049 Z",
    id: "Path",
    fill: "url(#linearGradient-4)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,91.6404005 L90,96.4792276 L26.1126163,133 C25.2393854,132.559456 24.3661545,131.973019 23.6386979,131.239256 C22.0380105,129.919056 20.7274565,128.159743 20,126.10578 L82.1423372,89 L87.5260817,92.3727326 L88.2535382,92.6659515 L90,91.6404005 Z",
    id: "Path",
    fill: "url(#linearGradient-5)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 52,
    x2: 88,
    y2: 93,
    id: "Path",
    stroke: "#2A6469",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,52 L158,121.725975 C157.855519,125.665078 155.961692,129.164607 153.193899,131.499049 C150.717899,133.686965 147.513832,135 144.01797,135 L33.1759284,135 C30.6999292,135 28.5157239,134.416745 26.4759992,133.250236 C25.6020338,132.812083 24.7280684,132.228829 24,131.499049 L31.1362036,127.268318 L86.7767783,94.3030422 L88.6691895,93.1351101 L90.4171203,92.1151255 L150.717899,56.230731 L158,52 Z",
    id: "Path",
    fill: "url(#linearGradient-6)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#2A6469",
    strokeWidth: 0.5,
    points: "158 52 90.4171203 91.8633061 88.6691895 92.8768878 86.7767783 94.0374884 24 131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.400113,101 L104.599887,101 C103.727093,101 103,100.319149 103,99.5 C103,98.6821809 103.727093,98 104.599887,98 L141.400113,98 C142.272907,98 143,98.6821809 143,99.5 C143,100.319149 142.272907,101 141.400113,101 Z",
    id: "Path",
    fill: "url(#linearGradient-7)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.400113,111 L104.599887,111 C103.727093,111 103,110.317819 103,109.5 C103,108.682181 103.727093,108 104.599887,108 L141.400113,108 C142.272907,108 143,108.682181 143,109.5 C143,110.317819 142.272907,111 141.400113,111 Z",
    id: "Path",
    fill: "url(#linearGradient-8)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.500704,46 C167.538196,46 170,43.5383036 170,40.5007058 C170,37.4631079 167.538196,35 164.500704,35 C161.461804,35 159,37.4631079 159,40.5007058 C159,43.5383036 161.461804,46 164.500704,46 Z",
    id: "Path",
    fill: "#3B7A80",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5006808,26 C20.4327952,26 22,24.4326117 22,22.5006827 C22,20.5673883 20.4327952,19 18.5006808,19 C16.5672048,19 15,20.5673883 15,22.5006827 C15,24.4326117 16.5672048,26 18.5006808,26 Z",
    id: "Path",
    fill: "#3B7A80",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5,35 C3.88157895,35 5,33.8801262 5,32.4992831 C5,31.1198738 3.88157895,30 2.5,30 C1.11985126,30 0,31.1198738 0,32.4992831 C0,33.8801262 1.11985126,35 2.5,35 Z",
    id: "Path",
    fill: "#3B7A80",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.5,23 C159.881459,23 161,21.8814386 161,20.500762 C161,19.1200853 159.881459,18 158.5,18 C157.118541,18 156,19.1200853 156,20.500762 C156,21.8814386 157.118541,23 158.5,23 Z",
    id: "Path",
    fill: "#3B7A80",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.5,98 C168.881459,98 170,96.8814386 170,95.499238 C170,94.1185614 168.881459,93 167.5,93 C166.120061,93 165,94.1185614 165,95.499238 C165,96.8814386 166.120061,98 167.5,98 Z",
    id: "Path",
    fill: "#EAEEF9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.700129,56.230731 L150.700129,63.5242609 L158,59.8767846 L158,52 L150.700129,56.230731 Z M150.700129,92.260228 L150.700129,104.076116 L158,100.42864 L158,88.6141743 L150.700129,92.260228 Z M150.700129,112.389631 L150.700129,121.434347 C150.553876,122.455755 150.26279,123.622264 149.677778,124.497146 C149.531525,124.643671 149.531525,124.788774 149.386691,124.935299 L158,120.559465 L158,108.743577 L150.700129,112.389631 Z M148.947932,133.541863 L146.758397,134.708373 C149.240438,134.27022 151.283721,133.103711 153.18217,131.645574 C153.18217,131.645574 153.18217,131.645574 153.328423,131.645574 C153.474676,131.645574 153.474676,131.499049 153.620929,131.353946 L148.947932,133.541863 Z M19,111.952901 L19,121.725975 L19,121.8725 C19,122.455755 19.146253,123.039009 19.292506,123.622264 L26.3012912,119.97621 L26.3012912,108.160322 L19,111.952901 Z M19,71.4010455 L19,83.2169338 L26.3012912,79.5694575 L26.3012912,67.7549919 L19,71.4010455 Z M19,52 L19,63.0861085 L26.3012912,59.4400548 L26.3012912,56.3758334 L19,52 Z M19,91.6769732 L19,103.492861 L26.3012912,99.8453852 L26.3012912,88.029497 L19,91.6769732 Z M32.8713174,127.70647 C32.1414722,127.70647 31.4116271,127.561368 30.828035,127.414843 C30.3892759,127.268318 30.0967699,127.123215 29.6594308,126.97669 C29.6594308,126.97669 29.6594308,126.97669 29.5131778,126.97669 L22.5043926,130.624167 C22.9431516,131.060896 23.2342377,131.353946 23.6729968,131.790676 C24.4028419,132.520456 25.2789401,132.957186 26.1550382,133.541863 C26.7386303,133.978593 27.4684755,134.27022 28.1997405,134.416745 L41.7785519,127.852995 L32.8713174,127.852995 L32.8713174,127.70647 Z M60.1751931,127.70647 L44.8441854,135 L61.4886303,135 L76.819638,127.70647 L60.1751931,127.70647 Z M94.9251931,127.70647 L79.5941854,135 L96.2386303,135 L111.569638,127.70647 L94.9251931,127.70647 Z M129.821446,127.70647 L114.490438,135 L127.922997,135 L143.254004,127.70647 L129.821446,127.70647 Z M150.700129,71.9843003 L150.700129,83.8001885 L158,80.1527123 L158,68.3382466 L150.700129,71.9843003 Z",
    id: "Shape",
    fill: "#1D5459",
    fillRule: "nonzero",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,133 L153,131 C152.838457,131.125533 152.838457,131.125533 152.676913,131.249848 C152.676913,131.249848 152.676913,131.249848 152.51537,131.249848 L148,133 Z",
    id: "Path",
    fill: "#526DFF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailReject);
export default __webpack_public_path__ + "static/media/email_reject.2218b14adfb350d29edde1553cdf105b.svg";
export { ForwardRef as ReactComponent };